import { useCallback } from 'react';

import type { ShareActionsOptions, ShareChannel } from 'src/app/shared/hooks/share';

export function useOnDashboardShareSuccess(): NonNullable<ShareActionsOptions<ShareChannel>['onSuccess']> {
	return useCallback((channel) => {
		switch (channel) {
			case 'facebook':
			default:
			// do nothing
		}
	}, []);
}
